<template>
  <div>
    <nav class="navigation navigation__utility" role="navigation" aria-label="Product detail internal navigation">
      <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
        <el-tab-pane class="tab" v-if="product.overview" :label="$t('productDetailOverviewHeading')"
          name="overview"></el-tab-pane>

        <el-tab-pane class="tab" v-if="product.specifications && product.specifications.length"
          :label="$t('productDetailSpecificationsHeading')" name="specifications"></el-tab-pane>

        <el-tab-pane class="tab" v-if="product.features && product.features.length"
          :label="$t('productDetailFeaturesHeading')" name="features"></el-tab-pane>

        <el-tab-pane class="tab" v-for="collection in productMediaCollections" :label="collection.heading"
          :name="'collection-' + collection.id" :key="collection.id">

        </el-tab-pane>
      </el-tabs>
    </nav>
  </div>
</template>

<script>
import i18n from '@/configured/vue-i18n';

export default {
  name: 'ProductDetailSubMenu',
  data() {
    return {
      activeName: 'overview'
    }
  },
  props: {
    product: {
      type: Object
    }
  },
  watch: {
    // Reset active tab when product changes
    'product.id'() {
      this.activeName = 'overview';
    }
  },
  methods: {
    handleClick(tab, event) {
      const element = document.getElementById(tab.name);
      const boundingBox = element.getBoundingClientRect();
      const header = document.getElementById('product_detail_header');
      const headerHeight = header.offsetHeight;
      this.$root.$emit('scrollTo', 0, boundingBox.top - headerHeight);
    }
  },
  computed: {
    productMediaCollections() {
      return (this.product.mediaCollections || []).filter((collection) => collection.media && collection.media.length > 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.navigation {

  &__utility {
    position: fixed;
    z-index: 100;
    bottom: 0;
    left: 10px;
    right: 0;
    background: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
  }
}
</style>
